import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useHistory, useLocation } from 'react-router'
import { selectors as licenseSelectors } from 'store/licenseManager'
import { operations as reportsOperations } from 'store/reportsManager'
import K8Tier2LessonCompletion from './component'
import ContentEntryDataGetter from 'layers/content/Hocs/ContentEntryDataGetter'
import withApiError from 'layers/errorHandling/apiError/component'
import {
  ERROR_TYPE_CONTENTFUL,
  SHOW_CONTENT_ON_401,
} from 'layers/errorHandling/apiError'

const K8Tier2LessonCompletionContainer = ({
  activeAdminK8Sites,
  resetSelectedProgram,
  selectedProgram,
  updateSelectedProgram,
}) => {
  const [siteId, setSiteId] = useState(null)
  const location = useLocation()
  const history = useHistory()
  const searchParams = useMemo(() => new URLSearchParams(location.search), [
    location.search,
  ])

  // Get gradeBand from URL parameters - this will cause re-render when URL changes
  const pathParts = location.pathname.split('/')
  const gradeBand =
    pathParts[pathParts.length - 1] === 'interventions'
      ? 'k-2'
      : pathParts[pathParts.length - 1] || 'k-2'

  const matchingSite = activeAdminK8Sites?.find(site => site.id === siteId)
  const isSetup = matchingSite?.sitePreferences?.k8?.isSetup

  useEffect(() => {
    if (!selectedProgram) {
      updateSelectedProgram({ key: 'K8', name: 'K8' })
    }
    const searchParamsSiteId =
      searchParams.get('siteId') || activeAdminK8Sites?.[0]?.id
    searchParams.set('siteId', searchParamsSiteId)
    history.replace({ search: searchParams.toString() })
    setSiteId(parseInt(searchParamsSiteId))
  }, [siteId])

  useEffect(() => {
    const cleanup = async () => {
      await resetSelectedProgram()
    }
    return cleanup
  }, [])

  return !siteId ? null : (
    <K8Tier2LessonCompletion
      gradeBand={gradeBand}
      isSetup={isSetup}
      selectedProgram={selectedProgram}
      siteId={siteId}
    />
  )
}

const mapStateToProps = state => {
  const {
    reportsManager: { selectedProgram },
  } = state
  const activeAdminK8Sites = licenseSelectors.selectActiveAdminK8Sites(state)

  return {
    activeAdminK8Sites,
    selectedProgram,
  }
}

const mapDispatchToProps = {
  resetSelectedProgram: reportsOperations.resetSelectedProgram,
  updateSelectedProgram: reportsOperations.updateSelectedProgram,
}

const mapper = entry => {
  const { displayTitle, onboardingSnapshot } = entry || {}
  return {
    displayTitle,
    onboardingSnapshot,
  }
}

const options = {
  entryId: '5oqdbnI289AADFVmm2sJyx',
  include: 5,
  mapper,
  spread: true,
}

K8Tier2LessonCompletionContainer.propTypes = {
  activeAdminK8Sites: PropTypes.array,
  resetSelectedProgram: PropTypes.func,
  selectedProgram: PropTypes.object,
  updateSelectedProgram: PropTypes.func,
}

export default ContentEntryDataGetter(
  withApiError(
    K8Tier2LessonCompletionContainer,
    [ERROR_TYPE_CONTENTFUL],
    [SHOW_CONTENT_ON_401],
  ),
  options,
  connect(mapStateToProps, mapDispatchToProps),
)
